import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import profileImage from "../assets/profile.jpg";

const AboutSection = () => {
  return (
    <section id="about" className="bg-black text-white py-20 px-6 md:px-20">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <img
            src={profileImage}
            alt="Kwame O. Sarfo, Entrepreneur, Investor, and Founder of Solonet Properties, Ice Chest Mineral Water, and Global Timber"
            className="rounded-2xl shadow-lg w-full max-w-md md:max-w-full object-cover border border-[#d4af37]/20"
          />
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-playfair mb-6 text-[#d4af37]">
            About Kwame O. Sarfo
          </h2>

          <p className="text-gray-300 leading-relaxed mb-6">
            Kwame O. Sarfo is a Ghanaian entrepreneur and visionary leader known
            for founding <strong>Solonet Properties</strong>,{" "}
            <strong>Ice Chest Mineral Water</strong>, and{" "}
            <strong>Global Timber Ltd</strong>. His ventures span real estate,
            water production, timber export, and strategic partnerships across
            oil, gas, and NGO initiatives driving growth and innovation in
            Ghana’s private sector.
          </p>

          <p className="text-gray-400 leading-relaxed mb-8">
            Guided by integrity, foresight, and purpose-driven leadership, Kwame
            continues to inspire transformation and empower the next generation
            of entrepreneurs across Africa.
          </p>

          <Link
            to="/about"
            className="inline-block mt-2 px-8 py-3 border border-[#d4af37] text-[#d4af37] rounded-full 
                       transition duration-300 hover:bg-[#d4af37] hover:text-black hover:shadow-[0_0_20px_rgba(212,175,55,0.4)]"
          >
            Continue Reading →
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
